import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import IframePage from "./iframe/IframeAllPages"
import { AuthProvider } from './context/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Zjisti, jestli aktuální URL je iframe-only verze
const pathname = window.location.pathname;

if (pathname.includes('/reservationform')) {
  root.render(
    <AuthProvider>
      <IframePage />
    </AuthProvider>
  );
} else {
  root.render(<App />);
}